
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import NiceButton from "@/components/UI/NiceButton.vue";
import { documentStore, singularityStore } from "@/store/store";
import { logSectionRewriteClick } from "@/lib/tracking/singularity";
import { findNode } from "@/lib/tree/tree";
import { getPageSectionFromNode } from "@/lib/singularity/page-structure/page-structure";

@Component({
  components: {
    NiceButton
  }
})
export default class EditWithAiButton extends Vue {
  @Prop({ required: true })
  nodeId!: string;

  openSectionRewrite() {
    const node = findNode(documentStore.document.tree, this.nodeId);
    if (!node) return;

    singularityStore.setSectionRewritePanelState({
      section: getPageSectionFromNode(node)
    });
    singularityStore.setSingularityLeftPanel("rewrite_section");

    logSectionRewriteClick(this.nodeId);
  }

  get isSectionCurrentlyRewritingWithAi() {
    return (
      singularityStore.aiJobs.filter(
        job =>
          "elementId" in job.context &&
          job.context.elementId === this.nodeId &&
          (job.status === "running" || job.status === "pending") &&
          job.context.jobType === "section_rewrite"
      ).length > 0
    );
  }
}
